import { __assign } from "tslib";
import { pickBy, identity, merge } from 'lodash';
function callFunctions(obj) {
    if (typeof obj === 'function') {
        return obj();
    }
    return obj;
}
function resolveValues(obj) {
    return Object.entries(obj).reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr[1] && curr[0]] = callFunctions(curr[1]), _a)));
    }, {});
}
function getCommonFields(obj) {
    if (!obj || Object.keys(obj).length === 0) {
        return {};
    }
    var _a = resolveValues(obj), bsi = _a.bsi, metaSiteId = _a.metaSiteId, visitorId = _a.visitorId, visitor_id = _a.visitor_id, // (visitorId) multiple variations, same value
    _appId = _a._appId, _instanceId = _a._instanceId, _msid = _a._msid, // (metaSiteId) multiple variations, same value
    _siteOwnerId = _a._siteOwnerId;
    return pickBy({
        bsi: bsi,
        visitorId: visitor_id || visitorId,
        appId: _appId,
        instanceId: _instanceId,
        metaSiteId: _msid || metaSiteId,
        siteOwnerId: _siteOwnerId,
    }, identity);
}
function fromBiLoggerFactory(biLoggerFactory) {
    var _a, _b, _c, _d;
    var obj = merge({}, (_b = (_a = biLoggerFactory === null || biLoggerFactory === void 0 ? void 0 : biLoggerFactory()) === null || _a === void 0 ? void 0 : _a.loggerClientFactory) === null || _b === void 0 ? void 0 : _b._defaults, (_d = (_c = biLoggerFactory === null || biLoggerFactory === void 0 ? void 0 : biLoggerFactory()) === null || _c === void 0 ? void 0 : _c.loggerClientFactory) === null || _d === void 0 ? void 0 : _d._nonEssentialDefaults);
    return getCommonFields(obj);
}
function fromBiObject(bi) {
    return getCommonFields(bi);
}
function fromBiLogger(biLogger) {
    var _a, _b;
    var obj = (_b = (_a = biLogger === null || biLogger === void 0 ? void 0 : biLogger.biLoggerClientFactoryInstance) === null || _a === void 0 ? void 0 : _a.loggerClientFactory) === null || _b === void 0 ? void 0 : _b._defaults;
    return getCommonFields(obj);
}
/**
 * Extracts essential BI fields for WixRicos' `BISettings`.
 *
 * Make sure to supply a combination of the following params, in any way you wish, that will
 * supply the following fields: `bsi`, `metaSiteId`, `visitorId`.
 *
 * You can provide them explicitly if you wish.
 * @param bi - contains `metaSiteId`, `visitorId`
 * @param biLogger - contains `bsi`, `_msid`, `visitor_id`
 * @param biLoggerFactory - contains `bsi`, `_msid`
 * @param platformAPIs - contains `biLogger` and `biLoggerFactory`
 * @returns Essential BI fields
 */
export var extractUoUParams = function (_a) {
    var _b = _a === void 0 ? {} : _a, bi = _b.bi, biLogger = _b.biLogger, biLoggerFactory = _b.biLoggerFactory, platformAPIs = _b.platformAPIs;
    return merge(fromBiObject(bi || (platformAPIs === null || platformAPIs === void 0 ? void 0 : platformAPIs.bi)), fromBiLogger(biLogger), fromBiLoggerFactory(biLoggerFactory || (platformAPIs === null || platformAPIs === void 0 ? void 0 : platformAPIs.biLoggerFactory)));
};
//# sourceMappingURL=biDefaultParams.js.map